const conversionRates: Record<string, number> = {
  USD: 1.1,
  EUR: 1,
  GBP: 0.85,
  CAD: 1.4,
  AUD: 1.5,
  NZD: 1.6,
  CHF: 1.05,
  CNY: 7.2,
  SEK: 10.5,
  NOK: 10.5,
  DKK: 7.4,
  RUB: 75,
  INR: 85,
  BRL: 6,
  PLN: 4.5,
  MXN: 20,
  ARS: 150,
  CLP: 850,
  COP: 4500,
  PHP: 60,
};

export function convertPrice(basePrice: number, targetCurrency: string): number {
  return basePrice * (conversionRates[targetCurrency] || 1);
}


const config = {
  locales: ['en', 'se', 'fr', 'es', 'de', 'it', 'nl', 'pl', 'cz', 'gr', 'dk'],
  defaultLocale: 'en',
  pathnames: {
    '/': {
      en: '/',
      fr: '/',
      es: '/',
      de: '/',
      it: '/',
      nl: '/',
      se: '/',
      pl: '/',
      cz: '/',
      gr: '/',
      dk: '/'
    },
    '/about': {
      en: '/about',
      fr: '/a-propos',
      es: '/acerca-de',
      de: '/ueber-uns',
      it: '/chi-siamo',
      nl: '/over-ons',
      se: '/om-oss',
      pl: '/o-nas',
      cz: '/o-nas',
      gr: '/gia-emas',
      dk: '/om-os'
    },
    '/articles': {
      en: '/articles',
      fr: '/articles',
      es: '/articulos',
      de: '/artikel',
      it: '/articoli',
      nl: '/artikelen',
      se: '/artiklar',
      pl: '/artykuly',
      cz: '/clanky',
      gr: '/articles',
      dk: '/artikler'
    },
    '/articles/[slug]': {
      en: '/articles/[slug]',
      fr: '/articles/[slug]',
      es: '/articulos/[slug]',
      de: '/artikel/[slug]',
      it: '/articoli/[slug]',
      nl: '/artikelen/[slug]',
      se: '/artiklar/[slug]',
      pl: '/artykuly/[slug]',
      cz: '/clanky/[slug]',
      gr: '/articles/[slug]',
      dk: '/artikler/[slug]'
    },
    '/products': {
      en: '/products',
      fr: '/produits',
      es: '/productos',
      de: '/produkte',
      it: '/prodotti',
      nl: '/producten',
      se: '/produkter',
      pl: '/produkty',
      cz: '/produkty',
      gr: '/products',
      dk: '/produkter'
    },
    '/products/[id]': {
      en: '/products/[id]',
      fr: '/produits/[id]',
      es: '/productos/[id]',
      de: '/produkte/[id]',
      it: '/prodotti/[id]',
      nl: '/producten/[id]',
      se: '/produkter/[id]',
      pl: '/produkty/[id]',
      cz: '/produkty/[id]',
      gr: '/products/[id]',
      dk: '/produkter/[id]'
    },
    '/products/[slug]': {
      en: '/products/[slug]',
      fr: '/produits/[slug]',
      es: '/productos/[slug]',
      de: '/produkte/[slug]',
      it: '/prodotti/[slug]',
      nl: '/producten/[slug]',
      se: '/produkter/[slug]',
      pl: '/produkty/[slug]',
      cz: '/produkty/[slug]',
      gr: '/products/[slug]',
      dk: '/produkter/[slug]'
    },
    '/contact': {
      en: '/contact',
      fr: '/contact',
      es: '/contacto',
      de: '/kontakt',
      it: '/contatti',
      nl: '/contact',
      se: '/kontakt',
      pl: '/kontakt',
      cz: '/kontakt',
      gr: '/contact',
      dk: '/kontakt'
    },
    '/privacy': {
      en: '/privacy',
      fr: '/politique-de-confidentialite',
      es: '/politica-de-privacidad',
      de: '/datenschutz',
      it: '/privacy',
      nl: '/privacy',
      se: '/integritetspolicy',
      pl: '/polityka-prywatnosci',
      cz: '/zpracovani-osobnich-udaju',
      gr: '/privacy-policy',
      dk: '/integritetspolitik'
    },
    '/terms': { 
      en: '/terms',
      fr: '/conditions-dutilisation',
      es: '/terminos-y-condiciones',
      de: '/nutzungsbedingungen',
      it: '/termini-e-condizioni',
      nl: '/voorwaarden',
      se: '/anvandningsvillkor',
      pl: '/warunki-uzytkowania',
      cz: '/podminky-vyuziti',
      gr: '/terms-of-use',
      dk: '/betingelser-for-brug'
    },
    '/dashboard': {
      en: '/dashboard',
      fr: '/tableau-de-bord',
      es: '/tablero',
      de: '/dashboard',
      it: '/dashboard',
      nl: '/dashboard',
      se: '/dashboard',
      pl: '/dashboard',
      cz: '/dashboard',
      gr: '/dashboard',
      dk: '/dashboard'
    },
    '/login': {
      en: '/login',
      fr: '/connexion',
      es: '/inicio-de-sesion',
      de: '/login',
      it: '/login',
      nl: '/login',
      se: '/login',
      pl: '/login',
      cz: '/login',
      gr: '/login',
      dk: '/login'
    },
    '/signup': {
      en: '/signup',
      fr: '/inscription',
      es: '/registro',
      de: '/registrierung',
      it: '/registrazione',
      nl: '/registreren',
      se: '/registrera',
      pl: '/rejestracja',
      cz: '/registrace',
      gr: '/signup',
      dk: '/registrer'
    },
    '/verify-email': {
      en: '/verify-email',
      fr: '/verifier-email',
      es: '/verificar-email',
      de: '/email-bestätigen',
      it: '/verifica-email',
      nl: '/email-bevestigen',
      se: '/verifiera-email',
      pl: '/weryfikacja-email',
      cz: '/overeni-email',
      gr: '/verify-email',
      dk: '/verifikation-af-email'
    },
    '/orders': {
      en: '/orders',
      fr: '/commandes',
      es: '/pedidos',
      de: '/bestellungen',
      it: '/ordini',
      nl: '/bestellingen',
      se: '/beställningar',
      pl: '/zamowienia',
      cz: '/objednavky',
      gr: '/orders',
      dk: '/bestillinger'
    },
    '/orders/[id]': {
      en: '/orders/[id]',
      fr: '/commandes/[id]',
      es: '/pedidos/[id]',
      de: '/bestellungen/[id]',
      it: '/ordini/[id]',
      nl: '/bestellingen/[id]',
      se: '/beställningar/[id]',
      pl: '/zamowienia/[id]',
      cz: '/objednavky/[id]',
      gr: '/orders/[id]',
      dk: '/bestillinger/[id]'
    },
    '/support/[id]': {
      en: '/support/[id]',
      fr: '/support/[id]',
      es: '/soporte/[id]',
      de: '/unterstützung/[id]',
      it: '/supporto/[id]',
      nl: '/ondersteuning/[id]',
      se: '/stöd/[id]',
      pl: '/wsparcie/[id]',
      cz: '/support/[id]',
      gr: '/support/[id]',
      dk: '/support/[id]'
    },
    '/compliance': {
      en: '/compliance',
      fr: '/conformite',
      es: '/cumplimiento',
      de: '/einhaltung',
      it: '/conformità',
      nl: '/conformiteit',
      se: '/överensstämmelse',
      pl: '/zgodnosc',
      cz: '/compliance',
      gr: '/compliance',
      dk: '/compliance'
    },
    '/cart': {
      en: '/cart',
      fr: '/panier',
      es: '/carrito',
      de: '/warenkorb',
      it: '/carrello',
      nl: '/winkelwagen',
      se: '/varukorg',
      pl: '/koszyk',
      cz: '/kosik',
      gr: '/cart',
      dk: '/kurv'
    },
    '/checkout': {
      en: '/checkout',
      fr: '/caisse',
      es: '/pago',
      de: '/bezahlen',
      it: '/pagamento',
      nl: '/betaling',
      se: '/betala',
      pl: '/platnosc',
      cz: '/platba',
      gr: '/checkout',
      dk: '/betaling'
    },
    'https://twitter.com/thcaspace': {
      en: 'https://twitter.com/thcaspace',
      fr: 'https://twitter.com/thcaspace',
      es: 'https://twitter.com/thcaspace',
      de: 'https://twitter.com/thcaspace',
      it: 'https://twitter.com/thcaspace',
      nl: 'https://twitter.com/thcaspace',
      se: 'https://twitter.com/thcaspace',
      pl: 'https://twitter.com/thcaspace',
      cz: 'https://twitter.com/thcaspace',
      gr: 'https://twitter.com/thcaspace',
      dk: 'https://twitter.com/thcaspace'
    },
    'mailto:support@thca.space': {
      en: 'mailto:support@thca.space',
      fr: 'mailto:support@thca.space',
      es: 'mailto:support@thca.space',
      de: 'mailto:support@thca.space',
      it: 'mailto:support@thca.space',
      nl: 'mailto:support@thca.space',
      se: 'mailto:support@thca.space',
      pl: 'mailto:support@thca.space',
      cz: 'mailto:support@thca.space',
      gr: 'mailto:support@thca.space',
      dk: 'mailto:support@thca.space'
    },
    '/auth/reset-password': {
      en: '/auth/reset-password',
      fr: '/auth/reinitialiser-le-mot-de-passe',
      es: '/auth/restablecer-contrasena',
      de: '/auth/passwort-zurücksetzen',
      it: '/auth/ripristina-password',
      nl: '/auth/wachtwoord-herstellen',
      se: '/auth/återställa-lösenord',
      pl: '/auth/reset-haslo',
      cz: '/auth/reset-heslo',
      gr: '/auth/reset-password',
      dk: '/auth/reset-adgangskode'
    },
    'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ': {
      en: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      fr: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      es: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      de: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      it: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      nl: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      se: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      pl: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      cz: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      gr: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ',
      dk: 'https://signal.me/#eu/913kN5emyhw0sORX4GrS-C8nUTnQNuqfiL83Nn_5Tq-17lh34Z1GurffO0FHBPGJ'
    },
    'https://visa.com': {
      en: 'https://visa.com',
      fr: 'https://visa.fr',
      es: 'https://visa.es',
      de: 'https://visa.de',
      it: 'https://visa.it',
      nl: 'https://visa.nl',
      se: 'https://visa.se',
      pl: 'https://visa.pl',
      cz: 'https://visa.cz',
      gr: 'https://visa.gr',
      dk: 'https://visa.dk'
    },
    'https://mastercard.com': {
      en: 'https://mastercard.com',
      fr: 'https://mastercard.fr',
      es: 'https://mastercard.es',
      de: 'https://mastercard.de',
      it: 'https://mastercard.it',
      nl: 'https://mastercard.nl',
      se: 'https://mastercard.se',
      pl: 'https://mastercard.pl',
      cz: 'https://mastercard.cz',
      gr: 'https://mastercard.gr',
      dk: 'https://mastercard.dk'
    },
    'https://ups.com': {
      en: 'https://ups.com',
      fr: 'https://ups.fr',
      es: 'https://ups.es',
      de: 'https://ups.de',
      it: 'https://ups.it',
      nl: 'https://ups.nl',
      se: 'https://ups.se',
      pl: 'https://ups.pl',
      cz: 'https://ups.cz',
      gr: 'https://ups.gr',
      dk: 'https://ups.dk'

    },
    'https://dhl.com': {
      en: 'https://dhl.com',
      fr: 'https://dhl.fr',
      es: 'https://dhl.es',
      de: 'https://dhl.de',
      it: 'https://dhl.it',
      nl: 'https://dhl.nl',
      se: 'https://dhl.se',
      pl: 'https://dhl.pl',
      cz: 'https://dhl.cz',
      gr: 'https://dhl.gr',
      dk: 'https://dhl.dk'
    },
    'https://dpd.com': {
      en: 'https://dpd.com',
      fr: 'https://dpd.fr',
      es: 'https://dpd.es',
      de: 'https://dpd.de',
      it: 'https://dpd.it',
      nl: 'https://dpd.nl',
      se: 'https://dpd.se',
      pl: 'https://dpd.pl',
      cz: 'https://dpd.cz',
      gr: 'https://dpd.gr',
      dk: 'https://dpd.dk'
    }
  },
  convertPrice,
};

export default config; 